module.exports = __webpack_public_path__ + "static/media/icon_14.fce52951.svg";